import React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import CircularProgress from '@mui/material/CircularProgress'
import TextField from '@mui/material/TextField'

import { ThemedComponent } from 'ui/theme'

export default function CompanyAutocomplete({
  options,
  showAccountDetails = false,
  value,
  inputValue,
  loading,
  placeholder,
  inputPlaceholder,
  noOptionsText,
  onInputChange,
  onChange,
}) {
  const hasSelectedCompany = Boolean(value?.id)

  return (
    <ThemedComponent>
      <Autocomplete
        fullWidth
        options={options || []}
        value={value || null}
        inputValue={inputValue}
        loading={loading}
        filterOptions={items => items}
        getOptionLabel={option => option?.name || ''}
        renderOption={(props, option) => <li {...props} key={option.id}>
          <div>{option.name}{showAccountDetails ? <div><small>
            {[option.salesforceAccountId, option.city, option.state, option.country, option.status].filter(Boolean).join(' · ')}
          </small></div> : null}</div>
        </li>}
        isOptionEqualToValue={(option, selected) => String(option?.id) === String(selected?.id)}
        noOptionsText={noOptionsText}
        onInputChange={(event, nextValue, reason) => {
          if (reason === 'input' || reason === 'clear') onInputChange(nextValue)
        }}
        onChange={(event, option) => onChange(option || null)}
        renderInput={params => (
          <TextField
            {...params}
            label={placeholder}
            placeholder={inputPlaceholder}
            variant="standard"
            InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={18} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            sx={{
              minHeight: 64,
              '& .MuiInputLabel-root': {
                color: theme => hasSelectedCompany
                  ? theme.palette.blue.main
                  : theme.palette.colors.subdued,
                fontSize: 16,
                fontWeight: 700,
                transition: 'color 0.2s ease',
                '&.Mui-focused': {
                  color: theme => theme.palette.blue.main,
                },
              },
              '& .MuiInputBase-root': {
                backgroundColor: theme => theme.palette.colors.surfaceElevated,
                border: theme => `1px solid ${theme.palette.colors.borderSoft}`,
                borderRadius: '10px',
                color: theme => theme.palette.colors.text,
                minHeight: 46,
                padding: '4px 12px !important',
                transition: 'border-color 0.22s ease, box-shadow 0.22s ease',
                '&.Mui-focused': {
                  borderColor: theme => theme.palette.blue.main,
                  boxShadow: theme => `0 0 0 4px ${theme.palette.colors.badgeMuted}`,
                },
              },
              '& .MuiAutocomplete-input': {
                color: theme => theme.palette.colors.text,
              },
              '& .MuiSvgIcon-root': {
                color: theme => theme.palette.colors.muted,
              },
            }}
          />
        )}
        componentsProps={{
          paper: {
            sx: {
              backgroundColor: theme => theme.palette.colors.surfaceElevated,
              border: theme => `1px solid ${theme.palette.colors.borderSoft}`,
              color: theme => theme.palette.colors.text,
            },
          },
        }}
      />
    </ThemedComponent>
  )
}
